// The Mac's license, as this client sees it (docs/features/licenses.md › Stage 2): the wire kind `license`
// (show → license) and `watchLicense(mac, link)`, which the app calls once a Mac's link is up and its identity
// key is pinned. The verdict stays on `mac.license` and in the log — no window, no Home item, nothing about plans
// or buying anywhere in the client.
import { registerWire } from '../core/wire.js'
import { pins } from '../core/pairing.js'
import { logLine } from '../core/log.js'
import { showLicense } from './show.js'
import { lastSeenRevoked } from './revoked.js'
import { acceptedModes } from './modes.js'

registerWire('license', (link, payload, message) => link.onLicense?.(message))

/// Which keys count here — for the license and for the revocation list alike — is modes.js: live only, test too
/// on staging, a local worker and a quick tunnel.
export function watchLicense(mac, link) {
  showLicense(mac, link, { pinned: mac.room ? pins.get(mac.room) : null, modes: acceptedModes(), revoked: lastSeenRevoked, log: logLine })
}
